import { combineReducers } from 'redux';

import home from './home/reducers';

export default combineReducers({
  home
});
